import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';


export const getNotifications = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/notification/search`, data)
        return await response.data
    } catch (error) {
        console.log("getNotifications - error", error);
        return handleApiError(error);
    }
}

export const insertNotification = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/notification/`, data)
        return await response.data
    } catch (error) {
        console.log("insertNotification - error", error);
        return handleApiError(error);
    }
}

export const updateNotificationById = async (notificationId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/notification/update/${notificationId}`, data)
        return await response.data
    } catch (error) {
        console.log("updateNotificationById - error", error)
        return handleApiError(error)
    }
}

export const updateNotificationStatusById = async (notificationId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/notification/status/${notificationId}`, data)
        return await response.data
    } catch (error) {
        console.log("updateNotificationStatusById - error", error)
        return handleApiError(error)
    }
}

export const readNotifications = async (userId, data) => {
    try {
        let queryStr = Object.keys(data).map(key => key + '=' + data[key]).join('&')
        if (queryStr){
            queryStr = `?${queryStr}`
        }
        const response = await axios.post(`${REACT_APP_API_URL}/notification/mark-as-read/user/${userId}${queryStr}`)
        return await response.data
    } catch (error) {
        console.log("readNotifications - error", error)
        return handleApiError(error)
    }
}